//import TextInput from "pixi-text-input";
import "pixi-spine";
//import "pixi-extra-filters";

import "../../libs/gsap.min";
import MotionPathPlugin from "../../libs/MotionPathPlugin.min";
gsap.registerPlugin(MotionPathPlugin);

// hax to get around p3lib w/ tweenmax (only using gsap for motion path plugin
window.TweenMax = undefined;
window.TweenMax2 = TweenMax;

import jquery from 'jquery';

global.$ = jquery;

import "../../libs/p3.min";

import Main from './Main';

const main = new Main(1024, 768);
main.init();